<template>
    <div class="products-slide">

        <div class="swiper-container">
            <div class="swiper-wrapper">
                <slot/>
            </div>
        </div>

        <div class="pagination"></div>
        <v-btn icon large outlined color="#dadada" class="prev-btn"><i class="icon icon-left-arrow"></i></v-btn>
        <v-btn icon large outlined color="#dadada" class="next-btn"><i class="icon icon-right-arrow"></i></v-btn>

    </div>
</template>

<script>
import Swiper from "swiper/bundle";
export default{
    props : {
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
        mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 2,
                    spaceBetween: 12,
                    allowTouchMove: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    pagination: {
                        el: '.products-slide .pagination',
                        clickable: true,
                    },
                    breakpoints: {
                        1024:{
                            slidesPerView: 3,
                            spaceBetween: 28,
                        },
                        1335:{
                            slidesPerView: 3,
                            spaceBetween: 28,
                            navigation: {
                                nextEl: ".products-slide .next-btn",
                                prevEl: ".products-slide .prev-btn",
                            },
                        },
                    },
                });
            });
        },
    },
}
</script>

<style scoped>
</style>